// extracted by mini-css-extract-plugin
export default {"wrapper":"Animated_wrapper__g1Tcz"};